/**
 * RCC Surface #13 — NEWESI / NEWOD / NOFUND / ZROCLS weekly exception reports.
 *
 * Light UI aggregator. Categories are legacy-inherited weekly cadence reports
 * that Compliance scans for anomalies. Full list generation is delegated to RAS.
 */

import { Link } from 'react-router';
import { Button, Pill } from '@/components/primitives';
import { SurfaceHeader } from '../components/SurfaceHeader';

interface Category {
  code: string;
  label: string;
  cadence: string;
  description: string;
}

const CATS: Category[] = [
  { code: 'NEWESI', label: 'New Estate Safekeeping Items', cadence: 'Weekly', description: 'New estate-flagged safekeeping items opened in the week.' },
  { code: 'NEWOD', label: 'New Overdraft', cadence: 'Daily', description: 'New overdraft events — scan for pattern / fee-waiver need.' },
  { code: 'NOFUND', label: 'Not-Funded Accounts', cadence: 'Daily', description: 'Accounts opened without funding — flag for 60-day close.' },
  { code: 'ZROCLS', label: 'Zero-Balance Closure', cadence: 'Weekly', description: 'Zero-balance accounts eligible for closure.' },
];

export function NewesiNewodNofundZrocls(): JSX.Element {
  return (
    <div>
      <SurfaceHeader
        title="Weekly Exception Categories"
        scope="Legacy weekly / daily exception scans. Each links to RAS for formal report generation + chain-of-custody log."
        surfaceNumber={13}
        role="FSR · Compliance oversight"
      />
      <div style={{ display: 'grid', gap: 'var(--sp-5)' }}>
        {CATS.map((c) => (
          <div
            key={c.code}
            style={{
              display: 'grid',
              gridTemplateColumns: '140px 1fr auto auto',
              alignItems: 'center',
              gap: 'var(--sp-5)',
              padding: 'var(--sp-5) var(--sp-6)',
              background: 'var(--surface-card)',
              border: '1px solid var(--surface-border)',
              borderRadius: 'var(--r-md)',
            }}
          >
            <div style={{ fontFamily: 'var(--font-mono)', fontWeight: 700, color: 'var(--pcb-blue)' }}>{c.code}</div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 13 }}>{c.label}</div>
              <div style={{ fontSize: 12, color: 'var(--ink-600)', marginTop: 2 }}>{c.description}</div>
            </div>
            <Pill variant="muted">{c.cadence}</Pill>
            <Link to={`/ras?templateCode=${encodeURIComponent(c.code)}`}>
              <Button variant="link" size="sm">
                Run →
              </Button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
